import css from 'styled-jsx/css';
import { rgba } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';
  @import 'src/common/styling/_mixins-scss/screen-size';

  .TransfersTable {
    &--with-switch-variants {
      margin-top: 24px;
    }

    .ReactDataTable__wrapper {
      @include respond-to(lg) {
        overflow-x: auto;
      }

      .ReactDataTable th,
      .ReactDataTable td {
        padding: 3px;
      }

      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(40px, 0.7fr) /* id */
            minmax(120px, 1.3fr) /* senderAccount */
            minmax(120px, 1.3fr) /* recipientAccount */
            minmax(110px, 1.5fr) /* status */
            minmax(100px, 1.3fr) /* amount */
            minmax(100px, 1.5fr) /* manager (если есть) */
            minmax(100px, 1.2fr) /* transferType */
            minmax(140px, 1.5fr); /* created */
        }

        .ReactDataTable__tbody-row {
          height: 70px;
          padding: 0 7px;
          align-items: center;
        }

        .ReactDataTable__tbody-cell {
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .TransfersTable__amount {
          font-weight: 500;
        }

        .TransfersTable__transferType {
          font-size: 13px;
          color: inherit;
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:nth-child(1) {
          flex: 4; /* accountFrom */
        }

        &:nth-child(2) {
          flex: 4; /* status */
        }

        &:nth-child(3) {
          flex: 3; /* amount */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:nth-child(1) {
          flex: 4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:nth-child(2) {
          flex: 4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:nth-child(3) {
          flex: 3;
        }
      }

      .ResponsiveTable__details-item {
        padding-left: 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .TransfersTable {
      .RowLink {
        justify-content: flex-start;
      }

      .TransfersTable__sender-id {
        color: ${colors.black.hex};
      }

      .TransfersTable__email {
        color: ${colors.secondary.hex};
        &:after {
          background: ${rgba([colors.secondary.rgb, 0.6])};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
